export const EXTERNAL_LINKS = {
  FOLDER_MANAGEMENT_HELP: 'https://policy.a2z.com/docs/501045/publication',
  PERMISSION_MANAGEMENT_HELP: 'https://policy.a2z.com/docs/501061/publication',
  DOCUMENT_MANAGEMENT_HELP: 'https://policy.a2z.com/docs/501049/publication',
  EXCEPTION_MANAGEMENT_HELP: 'https://policy.a2z.com/docs/592198/publication',
  PROCESS_MANAGEMENT_HELP: 'https://policy.a2z.com/docs/501221/publication',
  CREATE_ISSUE: 'https://issues.amazon.com/issues/create?template=7237de9e-1b31-4b64-8c96-62be3db8192a',
  // Dedicated template for document permission requests, used by the access-denied view when a
  // denial may be caused by a pending group-permission sync (D469789719). Kept separate from
  // CREATE_ISSUE so these reports land pre-triaged and remain countable.
  DOCUMENT_PERMISSION_REQUEST: 'https://issues.amazon.com/issues/create?template=45c8d6bb-c69e-4b6f-873c-a38c01273785',
  USER_GUIDE: 'https://policy.a2z.com/#folderId=24c12d49-7a52-b779-f8d4-444750b807fd/4ac12d47-cf19-82e6-b69e-02ec8be3c561/',
  SCHEDULED_REVIEWS: 'https://policy.a2z.com/docs/594305/publication',
};
